import { scheduleOrder } from 'constants/schedule';
import { Program } from 'reducers/programs/types';
import { ProgramData } from '../types';

type Schedule = ProgramData[];

const getProgramsSchedule = (programs: Program[]) => {
  if (!programs) return [];
  const schedule: Schedule[] = scheduleOrder.map(() => []);
  programs.forEach((item) => {
    if (item.schedule) {
      const programSchedule = Object.entries(item.schedule);
      const programData = item;
      programSchedule.forEach(([day, value]) => {
        if (value) {
          schedule[scheduleOrder.indexOf(day)].push({
            ...programData,
          });
        }
      });
    }
  });

  return schedule;
};

export default getProgramsSchedule;
